import React, { ChangeEvent, Fragment } from 'react';
import { CQMasterDataStore } from '../../../../../../store/cq-master-data.store';

export interface IPickList {
    type: string,
    category: string;
    onPicklistChange: Function;
}
const PickListUIType = ({ category,onPicklistChange }:IPickList) => {
    const fieldObj: any = CQMasterDataStore.Details.selectedFieldDetailsObject;

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.currentTarget;
        onPicklistChange({ type: 'picklist', category: value });
    }
    if (fieldObj.hasOwnProperty('formula')){
        return null;
    }
    return (
        <div data-testid='component-picklist-value-source.component'>
            {
                <div data-testid='display-field-picklist-value-source.component' className="form-rules-content">
                    {
                        <div data-testid="display-content">
                            <div className="slds-form-element">
                                <label className="slds-form-element__label">
                                    <abbr className="slds-required" title="required">* </abbr>Category</label>
                                <div className="slds-form-element__control">
                                    <input data-testid="input-picklistCategory"
                                        onChange={onChange}
                                        type="text"
                                        id="text-input-id-1"
                                        name="picklistValueSource"
                                        value={category}
                                        placeholder="Add category"
                                        required className="slds-input" />
                                </div>
                            </div>
                        </div>
                    }

                </div>
            }
        </div>
    );
}
export default PickListUIType;